import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import {AuthService} from '../../../service/authservice/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isRedirecting = false;


  constructor(private router: Router, private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // ✅ Get token (adjust based on your auth lib)

    const token = this.authService.getToken();

    let request = req;

    // ✅ Attach token if exists
    if (token) {
      request = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {

        if ((error.status === 401) && !this.isRedirecting) {
          this.isRedirecting = true;
          this.authService.logout();

          // ✅ optional: clear token
          localStorage.removeItem('access_token');

          this.router.navigate(['/login']);
        }

        return throwError(() => error);
      })
    );
  }
}
